import { Agentation } from "agentation"
import { Router, Routes, Route } from "./lib/router"
import { LanguageProvider } from "./lib/LanguageContext"
import RequireRole from "./lib/RequireRole"
import Landing from "./pages/Landing"
import Login from "./pages/Login"
import Signup from "./pages/Signup"
import DashboardRedirect from "./pages/DashboardRedirect"
import VerificationPending from "./pages/VerificationPending"
import AdminDashboard from "./pages/AdminDashboard"
import AdminClubs from "./pages/AdminClubs"
import AdminEvents from "./pages/AdminEvents"
import AdminDatabase from "./pages/AdminDatabase"
import AdminResultsIngestion from "./pages/AdminResultsIngestion"
import LiveResults from "./pages/LiveResults"

import CoachDashboard from "./pages/CoachDashboard"
import CoachAthletes from "./pages/CoachAthletes"
import CoachVerification from "./pages/CoachVerification"
import CoachResults from "./pages/CoachResults"

import SwimmerDashboard from "./pages/SwimmerDashboard"
import SwimmerEvents from "./pages/SwimmerEvents"
import SwimmerResults from "./pages/SwimmerResults"
import SwimmerWorkouts from "./pages/SwimmerWorkouts"
import SwimmerGoals from "./pages/SwimmerGoals"
import SwimmerProfile from "./pages/SwimmerProfile"

import ClubAdminDashboard from "./pages/ClubAdminDashboard"
import ClubAdminMyClub from "./pages/ClubAdminMyClub"

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<DashboardRedirect />} />
          <Route path="/verification-pending" element={<VerificationPending />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/admin" element={<RequireRole role="admin"><AdminDashboard /></RequireRole>} />
          <Route path="/admin/dashboard" element={<RequireRole role="admin"><AdminDashboard /></RequireRole>} />
          <Route path="/admin/clubs" element={<RequireRole role="admin"><AdminClubs /></RequireRole>} />
          <Route path="/admin/events" element={<RequireRole role="admin"><AdminEvents /></RequireRole>} />
          <Route path="/admin/database" element={<RequireRole role="admin"><AdminDatabase /></RequireRole>} />
          <Route path="/admin/results" element={<RequireRole role="admin"><AdminResultsIngestion /></RequireRole>} />
          <Route path="/results" element={<LiveResults />} />

          <Route path="/coach" element={<RequireRole role="coach"><CoachDashboard /></RequireRole>} />
          <Route path="/coach/dashboard" element={<RequireRole role="coach"><CoachDashboard /></RequireRole>} />
          <Route path="/coach/athletes" element={<RequireRole role="coach"><CoachAthletes /></RequireRole>} />
          <Route path="/coach/verification" element={<RequireRole role="coach"><CoachVerification /></RequireRole>} />
          <Route path="/coach/results" element={<RequireRole role="coach"><CoachResults /></RequireRole>} />

          <Route path="/swimmer" element={<RequireRole role="swimmer"><SwimmerDashboard /></RequireRole>} />
          <Route path="/swimmer/dashboard" element={<RequireRole role="swimmer"><SwimmerDashboard /></RequireRole>} />
          <Route path="/swimmer/events" element={<RequireRole role="swimmer"><SwimmerEvents /></RequireRole>} />
          <Route path="/swimmer/results" element={<RequireRole role="swimmer"><SwimmerResults /></RequireRole>} />
          <Route path="/swimmer/workouts" element={<RequireRole role="swimmer"><SwimmerWorkouts /></RequireRole>} />
          <Route path="/swimmer/goals" element={<RequireRole role="swimmer"><SwimmerGoals /></RequireRole>} />
          <Route path="/swimmer/profile" element={<RequireRole role="swimmer"><SwimmerProfile /></RequireRole>} />

          <Route path="/club-admin" element={<RequireRole role="club"><ClubAdminDashboard /></RequireRole>} />
          <Route path="/club-admin/dashboard" element={<RequireRole role="club"><ClubAdminDashboard /></RequireRole>} />
          <Route path="/club-admin/my-club" element={<RequireRole role="club"><ClubAdminMyClub /></RequireRole>} />
        </Routes>
        {process.env.NODE_ENV !== "production" && <Agentation />}
      </Router>
    </LanguageProvider>
  )
}

export default App

